(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  class HeroSlider {
    constructor(el) {
      this.el        = el;
      this.track     = el.querySelector('.hero-slider__track');
      this.slides    = Array.from(el.querySelectorAll('.hero-slider__slide'));
      this.arrows    = el.querySelectorAll('.hero-slider__arrow');
      this.autoplay  = el.dataset.autoplay === 'true';
      this.speed     = parseInt(el.dataset.speed, 10) || 5000;
      this.current   = 0;
      this.animating = false;
      this.timer     = null;

      if (this.slides.length < 2) return;

      this.arrows.forEach(btn => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'prev' ? -1 : 1;
          this.go(this.current + dir);
        });
      });

      // Keyboard
      this.el.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  this.go(this.current - 1);
        if (e.key === 'ArrowRight') this.go(this.current + 1);
      });

      // Touch / swipe
      let startX = null;
      this.el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.el.addEventListener('touchend', e => {
        if (startX === null) return;
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) this.go(this.current + (diff > 0 ? 1 : -1));
        startX = null;
      }, { passive: true });

      if (this.autoplay) this.startAutoplay();
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
    }

    go(index) {
      if (this.animating) return;
      const total  = this.slides.length;
      const next   = ((index % total) + total) % total;
      if (next === this.current) return;

      this.animating = true;

      const leaving  = this.slides[this.current];
      const entering = this.slides[next];

      // Freeze container height during transition
      const h = leaving.getBoundingClientRect().height;
      this.el.style.height = h + 'px';

      entering.classList.add('is-entering');
      leaving.classList.add('is-leaving');
      leaving.classList.remove('is-active');
      entering.classList.add('is-active');

      const duration = 700;
      setTimeout(() => {
        leaving.classList.remove('is-leaving');
        entering.classList.remove('is-entering');
        this.el.style.height = '';
        this.current   = next;
        this.animating = false;
      }, duration);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(this.current + 1), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
    }
  }

  document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el));

  // Shopify editor re-init
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.hero-slider');
    if (el) new HeroSlider(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.fa-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var track = document.getElementById(btn.dataset.carousel);
        if (!track) return;
        var amount = track.clientWidth * 0.75;
        track.scrollBy({
          left: btn.classList.contains('fa-btn--prev') ? -amount : amount,
          behavior: 'smooth'
        });
      });
    });

    document.querySelectorAll('.fa-carousel').forEach(function (track) {
      var section = track.closest('.fa-section');
      if (!section) return;
      var prev = section.querySelector('.fa-btn--prev');
      var next = section.querySelector('.fa-btn--next');
      if (!prev || !next) return;

      function sync() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      sync();
      track.addEventListener('scroll', sync, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-all"] && !Shopify.designMode) return;
  try {
    
/* ══ Scroll the carousel by roughly one viewport of slides ══ */
function psScroll(sectionId, dir) {
  const track = document.getElementById('ps-track-' + sectionId);
  if (!track) return;

  const slide = track.querySelector('.ps-slide');
  const styles = getComputedStyle(track);
  const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
  const step = slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
  const perView = Math.max(1, Math.round(track.clientWidth / step));

  track.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
}

/* ══ Toggle arrow state at the ends / hide when nothing to scroll ══ */
function psUpdateArrows(sectionId) {
  const track = document.getElementById('ps-track-' + sectionId);
  if (!track) return;
  const carousel = track.closest('.ps-carousel');
  if (!carousel) return;

  const prev = carousel.querySelector('.ps-arrow--prev');
  const next = carousel.querySelector('.ps-arrow--next');
  const maxScroll = track.scrollWidth - track.clientWidth - 1;
  const scrollable = track.scrollWidth > track.clientWidth + 2;

  if (prev) {
    prev.disabled = track.scrollLeft <= 0;
    prev.style.display = scrollable ? '' : 'none';
  }
  if (next) {
    next.disabled = track.scrollLeft >= maxScroll;
    next.style.display = scrollable ? '' : 'none';
  }
}

/* ══ Init every carousel on the page ══ */
function psInitCarousels() {
  document.querySelectorAll('.ps-track').forEach(function (track) {
    const sectionId = track.dataset.sectionId;
    psUpdateArrows(sectionId);
    track.addEventListener('scroll', function () { psUpdateArrows(sectionId); }, { passive: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', psInitCarousels);
} else {
  psInitCarousels();
}

window.addEventListener('resize', function () {
  document.querySelectorAll('.ps-track').forEach(function (t) {
    psUpdateArrows(t.dataset.sectionId);
  });
});

/* Theme editor: re-init when a section is (re)loaded */
document.addEventListener('shopify:section:load', psInitCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var STORAGE_KEY = 'shopify_wishlist';
  var grid     = document.getElementById('wishlist-grid');
  var empty    = document.getElementById('wishlist-empty');
  var count    = document.getElementById('wishlist-count');
  var clearBtn = document.getElementById('wl-clear-btn');

  if (!grid) return;


  /* ── Storage helpers ──────────────────────────── */
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) {}
  }

  /* Get product ID from a stored entry (handles both legacy strings and rich objects) */
  function entryId(item) {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') return String(item);
    if (typeof item === 'object') return String(item.id || '');
    return '';
  }


  /* ── Reveal cards whose IDs are in localStorage ── */
  function render() {
    var list = getList();
    var ids = list.map(entryId).filter(Boolean);

    /* Hide everything first */
    var allCards = grid.querySelectorAll('.wl-card-wrap');
    allCards.forEach(function (c) {
      c.hidden = true;
      c.style.display = 'none';
    });

    if (ids.length === 0) {
      grid.style.display = 'none';
      empty.style.display = 'flex';
      updateCount(0);
      return;
    }

    /* Reveal matching cards, append in wishlist order */
    var matched = 0;
    ids.forEach(function (id) {
      var card = grid.querySelector('.wl-card-wrap[data-wl-id="' + CSS.escape(id) + '"]');
      if (card) {
        card.hidden = false;
        card.style.display = '';
        grid.appendChild(card); /* reorder to end → preserves wishlist order */
        matched++;
      }
    });

    if (matched > 0) {
      grid.style.display = '';
      empty.style.display = 'none';
    } else {
      /* IDs in storage but no matching cards rendered server-side
         (e.g. product not in source collection or out of paginate range) */
      grid.style.display = 'none';
      empty.style.display = 'flex';
    }

    updateCount(ids.length);
  }


  /* ── Count bubble ─────────────────────────────── */
  function updateCount(n) {
    if (!count) return;
    count.textContent = n;
    count.style.transform = 'scale(1.35)';
    setTimeout(function () { count.style.transform = 'scale(1)'; }, 220);

    var badge = document.getElementById('wishlist-header-count');
    if (badge) badge.textContent = n;
  }


  /* ── Remove card via heart click on this page ── */
  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-wishlist, .product-media-wishlist-btn, [data-wishlist-toggle]');
    if (!btn) return;

    /* Stop the global product-card handler — we own this one */
    e.stopPropagation();
    e.preventDefault();

    var wrap = btn.closest('.wl-card-wrap');
    if (!wrap) return;

    var id = wrap.getAttribute('data-wl-id');

    /* Visual: pop heart, slide card out */
    btn.classList.remove('pc-wishlist--pop');
    void btn.offsetWidth;
    btn.classList.add('pc-wishlist--pop');
    btn.classList.remove('pc-wishlist--active');

    wrap.classList.add('removing');
    setTimeout(function () {
      wrap.hidden = true;
      wrap.style.display = 'none';
      wrap.classList.remove('removing');

      /* If empty now, show empty state */
      var visible = grid.querySelectorAll('.wl-card-wrap:not([hidden])').length;
      if (visible === 0) {
        grid.style.display = 'none';
        empty.style.display = 'flex';
      }
    }, 280);

    /* Remove from localStorage */
    var newList = getList().filter(function (item) {
      return entryId(item) !== String(id);
    });
    saveList(newList);
    updateCount(newList.length);

    /* Notify rest of page (e.g. PDP heart) */
    document.dispatchEvent(new CustomEvent('wishlist:remove', {
      bubbles: true,
      detail: { id: id }
    }));
  }, true);  /* useCapture so we intercept before product-card's own handler */


  /* ── Clear all ────────────────────────────────── */
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      var visible = grid.querySelectorAll('.wl-card-wrap:not([hidden])');
      if (visible.length === 0) return;
      if (!confirm('Clear your entire wishlist?')) return;

      visible.forEach(function (w) { w.classList.add('removing'); });

      setTimeout(function () {
        visible.forEach(function (w) {
          w.hidden = true;
          w.style.display = 'none';
          w.classList.remove('removing');
        });
        saveList([]);
        grid.style.display = 'none';
        empty.style.display = 'flex';
        updateCount(0);
        document.dispatchEvent(new CustomEvent('wishlist:cleared', { bubbles: true }));
      }, 300);
    });
  }


  /* ── React to add/remove from other pages ─────── */
  document.addEventListener('wishlist:add', render);
  document.addEventListener('wishlist:remove', render);


  /* ── Boot ─────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  /* Expose for debugging */
  window.wlRender = render;
})();

  } catch(e) { console.error(e); }
})();
})();
